// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"12":"profiler","777":"recorder"}[chunkId] || chunkId) + "." + {"12":"c137718d","453":"e78dff23","777":"7a1e3176"}[chunkId] + ".chunk.js";
};